import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

const ClusterInfo: FC = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};
export default ClusterInfo;
